import { account } from '../classes/Account'
import { apiURL } from './URLs'
import { getTrackingHeaders, setStoredSessionId } from './tracking/sessionStorage'

export async function refreshAccessToken() {
  const refreshTokenResponse = await fetch(`${apiURL}/api/access-token/refresh`, {
    credentials: 'include',
    headers: getTrackingHeaders()
  })
  const refreshTokenData = await refreshTokenResponse.json()
  if(refreshTokenData.response.error) {
    localStorage.removeItem('portalAccessToken')
    return ''
  } else {
    if (refreshTokenData.response.sessionId)
      setStoredSessionId(refreshTokenData.response.sessionId)
    localStorage.setItem('portalAccessToken', refreshTokenData.response.accessToken)
    account.accessToken = refreshTokenData.response.accessToken
    return refreshTokenData.response.accessToken
  }
}

export const applicationPage2 = [
  'Amusement Parks',
  'Automotive Dealership or Repair',
  'Cannabis',
  'Childcare/Educations/Schools (Primary, Higher Edu, etc.)',
  'Churches',
  'Construction',
  'Entertainment/Production',
  'Gyms/Fitness',
  'Healthcare (Non-Nursing Home or Rehab)',
  'Hotels/Hospitality',
  'Manufacturer',
  'Non-Profit',
  'Nursing Home, Skilled Nursing Facility/Assisted Living, Home Health Agencies',
  'Professional Business Services and/or Consulting',
  'Rehabilitation Center',
  'Restaurants, Food & Beverage',
  'Retail',
  'Transportation',
  'Other' 
]

export const applicationPage3 = [
  'Permanent closure of business for a period of time',
  'Partial restriction of internal operations',
  'Partial restriction of service/product delivery',
  'Capacity limits',
  'Social distancing requirements',
  'Difficulty obtaining PPE leading to reduced operational capacity',
  'Enhanced cleaning protocols that reduced operational capacity',
  'Travel restrictions (conferences, client visits, biz dev, etc.)',
  'Reduced hours of operation',
  'Workforce capacity issues due to high COVID-19 infection rate amongst staff',
  'Delay or difficulty in obtaining necessary permits/licenses required to conduct business',
  'Supply chain disruption resulting in significant disruption or delay',
  'Material impact on staff productivity levels due to remote work',
  'Closure of government agencies normally required to conduct business as usual',
  'None of the above'
]

/**
 * @param {String} phoneNumber 
 * @returns 
 */
export function formatPhoneNumber(phoneNumber) {
  const digits = phoneNumber.replace(/^\+1|\D/g, '')

  if (digits.length === 10)
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  else
    return phoneNumber
}